
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('products', { comparison: 'getComparison', mortgage: 'get' }),
      ...mapGetters('search', { search: 'get' }),
      savings () {
        if (!this.search || !this.comparison || !this.search.rtc || this.search.purpose !== 'SM' || this.mortgage.rate_type !== 'FIX') {
          return null;
        }
        const positive = this.comparison.fixed_period_savings > 0;
        const i18nKey = `results.cards.fixedSavings.${positive ? 'positive' : 'negative'}`;
        const s = {
          icon: positive ? ['far', 'check'] : ['far', 'xmark'],
          text: this.$t(i18nKey, [this.$n(Math.abs(this.comparison.fixed_period_savings), 'currency'), this.comparison.fixed_period_years])
        };
        s[`data-${positive ? 'green' : 'danger'}`] = true;
        return s;
      }
    }
  };
